import { useDispatch, useSelector } from 'react-redux';

import {
  selectEssSwitch,
} from 'shared/slice/essSwitchSlice';

import {
  selectTesSwitch,
} from 'shared/slice/tesSwitchSlice';

import { useMediaQuery } from 'react-responsive';
import styled, { css } from 'styled-components';

import SSRInfoContainer from './SSRInfoContainer';

import SSRToggleSWitch from './SSRToggleSwitch';
import SSRSelect from './SSRSelect';
import {
  alignItemsFlexStart,
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentFlexEnd,
  justifyContentSpaceBetween,
  layerA,
} from 'shared/styles/commonStyles';
import SSRInfoCommonContainer from './SSRInfoCommonCopntainer';
import { useState } from 'react';
import { useEffect } from 'react';
import {
  handlePasswordPropagation,
  selectUserInfo,
  selectUserPermissions,
} from 'shared/slice/userSlice';
import {
  selectSsrUiEntry,
  setSsrPasswordBox,
  setSsrSettingOpen,
} from 'shared/slice/ssrUiSlice';
import { useQueryClient } from 'react-query';
import { ssrStateKey } from 'shared/hooks/useSsrState';
import { setSsrField } from 'shared/helpers/ssrCache';
import {
  updateBlowerSettingService,
  updateSwitchSettingService,
} from 'shared/services';
import SwitchNameSelector from './SwitchNameSelector';
import AdminSSRItemDetails from './AdminSSRItemDetails';
import ContainerLogin from 'shared/components/adminPassword/ContainerLogin';

const EMPTY_SPECS = [];
const EMPTY_DISPLAY_SPECS = [{}];

const SSRDetail = ({
  swtName,
  data,
  id,
  location,
  machine,
  indivLocationName,
  isUpdating,
  setIsUpdating,
  localActivatedHeaters,
  setLocalActivatedHeaters
}) => {
  const permissions = useSelector(selectUserPermissions);
  const disable = !permissions.WRITE;

  const { flatEssSwitch,flatTesSwitch } = useSelector(
    swtName === 'ess' ? selectEssSwitch : selectTesSwitch
  );
  const queryClient = useQueryClient();
  const switchData = swtName === 'ess' ? flatEssSwitch : flatTesSwitch;

  const switchStatus = switchData[location][machine];

  const { deviceMac, heaterThermocoupleMap, activeThermocouples } = switchStatus;

  const specs = Array.isArray(data?.specs) ? data.specs : EMPTY_SPECS;
  const displaySpecs = specs.length > 0 ? specs : EMPTY_DISPLAY_SPECS;
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });
  const { buttonStatus } = data;
  const { isSettingOpen, openPasswordBox } = useSelector((s) =>
    selectSsrUiEntry(s, { swtName, location, machine, id: `ssr${id}` })
  );
  const { isAdministrator, isPasswordBoxOpen } = useSelector(selectUserInfo);
  const dispatch = useDispatch();

  const [isOverAmp, setIsOverAmp] = useState(false);
  const [SSRSwitchName, setSSRSwitchName] = useState('');

  const disabled = buttonStatus === 'flt' || buttonStatus === 'off';


  useEffect(() => {
    const check = specs.some((spec) => {
      const rated = Number(spec?.current);
      const actual = Number(spec?.currentSSR ?? spec?.currentCurrent);

      if (!Number.isFinite(rated) || !Number.isFinite(actual)) return false;

      return actual > rated * 1.2 || actual < rated * 0.8;
    });

    setIsOverAmp(check);
  }, [specs]);


useEffect(() => {

}, [localActivatedHeaters]);

  const setSettingOpen = (status) =>
    dispatch(
      setSsrSettingOpen({
        swtName,
        location,
        machine,
        id: `ssr${id}`,
        status,
      })
    );

  const closePasswordBox = () => {
    dispatch(
      setSsrPasswordBox({
        swtName,
        location,
        machine,
        id: `ssr${id}`,
        status: false,
      })
    );
    dispatch(handlePasswordPropagation(false));
  };

  const handleMobileSettingButton = () => {
    if (isSettingOpen) {
      setSettingOpen(false);
    } else if (isAdministrator) {
      setSettingOpen(true);
    } else if (!isPasswordBoxOpen) {
      dispatch(
        setSsrPasswordBox({
          swtName,
          location,
          machine,
          id: `ssr${id}`,
          status: true,
        })
      );
      dispatch(handlePasswordPropagation(true));
    }
  };
  const integratedButtonHandler = (data) => {
    switch (data.button) {
      case 'SSRSelect':
        const newHeaterThermocoupleMap = {
          heater_thermocouple_map: heaterThermocoupleMap.map(
            (select, index) => {
              if (index === id - 1) {
                return Number(data.data.slice(-2));
              } else {
                return select;
              }
            }
          ),
        };
        swtName === 'ess'
          ? updateSwitchSettingService(
              [deviceMac],
              newHeaterThermocoupleMap
            ).then(() => {
              queryClient.setQueryData(ssrStateKey(machine), (prev) =>
                setSsrField(prev, data.id, 'select', data.data)
              );
            })
          : updateBlowerSettingService(
              [deviceMac],
              newHeaterThermocoupleMap
            ).then(() => {
              queryClient.setQueryData(ssrStateKey(machine), (prev) =>
                setSsrField(prev, data.id, 'select', data.data)
              );
            });
        break;
      case 'toggle':
        if (isUpdating) return;
  setIsUpdating(true);
        const newActivatedHeaters = {
          activated_heaters: localActivatedHeaters.map((value, index) => {
            if (index === id - 1) {
              return Number(data.buttonStatus === 'on' ? 1 : 0);
            } else {
              return value;
            }
          }),
        };
     swtName === 'ess'
    ? updateSwitchSettingService([deviceMac], newActivatedHeaters).then(
        (serverData) => {



        const isDifferent = serverData[0]?.activated_heaters?.some(
  (val, idx) => val !== newActivatedHeaters.activated_heaters[idx]
) ?? true;


          if (!isDifferent) {
            queryClient.setQueryData(ssrStateKey(machine), (prev) =>
              setSsrField(prev, data.id, 'buttonStatus', data.buttonStatus)
            );
            setLocalActivatedHeaters(serverData[0]?.activated_heaters);

            setIsUpdating(false);
          }
        }
      )
    : updateBlowerSettingService([deviceMac], newActivatedHeaters).then(
        (serverData) => {


        const isDifferent = serverData[0]?.activated_heaters?.some(
  (val, idx) => val !== newActivatedHeaters.activated_heaters[idx]
) ?? true;


          if (!isDifferent ) {
            queryClient.setQueryData(ssrStateKey(machine), (prev) =>
              setSsrField(prev, data.id, 'buttonStatus', data.buttonStatus)
            );
            setIsUpdating(false);
          }
        }
      );


        break;
      default:
        break;
    }
  };

  return (
    <>
      {isMobile ? (
        <Wrapper
          isMobile={isMobile}
          isOverAmp={isOverAmp}
          isOff={buttonStatus === 'off'}
          isFault={buttonStatus === 'flt'}
        >
          <MobileHeaderRow>
            <ToggleSWitchContainer isMobile={true}>
              <SSRToggleSWitch
                isMobile={true}
                data={data}
                id={id}
                buttonHandler={integratedButtonHandler}
                disable={disable}
                switch_panels={switchStatus?.switch_panels}
                isUpdating={isUpdating}
                setIsUpdating={setIsUpdating}
              />
            </ToggleSWitchContainer>

            <SSRSelect
              isMobile={true}
              data={data.select}
              status={data.buttonStatus}
              id={id}
              buttonHandler={integratedButtonHandler}
              activeThermocouples={activeThermocouples}
            />

            <MobileSettingButton
              type='button'
              disabled={disable}
              aria-label={
                isSettingOpen
                  ? `close ssr ${id} heater settings`
                  : `open ssr ${id} heater settings`
              }
              onClick={() => !disable && handleMobileSettingButton()}
            >
              <MobileSettingIcon src='/images/admin-setting.svg' />
            </MobileSettingButton>
          </MobileHeaderRow>

          {isSettingOpen ? (
            <AdminSSRItemDetails
              isMobile={true}
              id={id}
              data={data}
              isEnable={buttonStatus === 'on'}
              isFault={buttonStatus === 'flt'}
              isWarn={data.warn === 1}
              handleButtonClick={() => setSettingOpen(false)}
              location={location}
              machine={machine}
              swtName={swtName}
            />
          ) : (
            displaySpecs.map((spec, index) => {
              const current = spec?.current ?? 0;
              const actualCurrent = spec?.currentSSR ?? spec?.currentCurrent ?? 0;
              const wattage = spec?.wattage ?? 0;
              const voltage = spec?.voltage ?? 0;
              const lengths = spec?.lengths ?? 0;
              const elementName = spec?.elementName || '';
              const partNumber = spec?.partNumber || '';

              return (
                <HeaterBlock key={`${partNumber || 'heater'}-${index}`}>
                  {displaySpecs.length > 1 && (
                    <HeaterBlockTitle>
                      heater {index + 1} of {displaySpecs.length}
                    </HeaterBlockTitle>
                  )}
                  <HeaterFigures>
                    <SSRInfoCommonContainer
                      data={{ t: current, a: actualCurrent }}
                      title='current'
                      unit='a'
                      disabled={disable}
                    />
                    <SSRInfoCommonContainer
                      data={wattage}
                      title='wattage'
                      unit='w'
                      disabled={disabled}
                    />
                    <SSRInfoCommonContainer
                      data={voltage}
                      title='voltage'
                      unit='v'
                      disabled={disabled}
                    />
                    <SSRInfoCommonContainer
                      data={lengths}
                      title='length'
                      unit='ft'
                      disabled={disabled}
                    />
                  </HeaterFigures>
                  <SectionContainer isLast={true}>
                    <SSRInfoCommonContainer
                      disabled={disabled}
                      data={{
                        a: `${elementName} - ${partNumber}`,
                        b: `${current} a / ${wattage} w / ${voltage} v / ${lengths} ft`,
                      }}
                      title='description'
                      unit={null}
                    />
                  </SectionContainer>
                </HeaterBlock>
              );
            })
          )}

          {openPasswordBox && (
            <MobilePasswordWrapper onClick={closePasswordBox}>
              <ContainerLogin
                setIsSettingOpen={() => setSettingOpen(true)}
                handleClose={closePasswordBox}
                isReadyToClose={true}
              />
            </MobilePasswordWrapper>
          )}
        </Wrapper>
      ) : (
        <Wrapper>
          <FlexContainer>
            <SSRSelect
              isMobile={false}
              data={data.select}
              status={data.buttonStatus}
              id={id}
              buttonHandler={integratedButtonHandler}
              activeThermocouples={activeThermocouples}
            />

            <ToggleSWitchContainer>
              <SSRToggleSWitch
                isMobile={false}
                data={data}
                id={id}
                buttonHandler={integratedButtonHandler}
                disable={disable}
                switch_panels={switchStatus?.switch_panels}
                isUpdating={isUpdating}
                setIsUpdating={setIsUpdating}
              />
            </ToggleSWitchContainer>

            <SSRInfoContainer
              swtName={swtName}
              data={data}
              id={id}
              location={location}
              machine={machine}
              isSettingOpen={isSettingOpen}
              isOverAmp={isOverAmp}
              SSRSwitchName={SSRSwitchName}
              setSSRSwitchName={setSSRSwitchName}
            />
          </FlexContainer>
          <SwitchNameSelectorWrapper>
            {isSettingOpen && (
              <>
                <SwitchNameSelector
                  data={data}
                  SSRSwitchName={SSRSwitchName}
                  setSSRSwitchName={setSSRSwitchName}
                  ssrId={id - 1}
                  swtName={swtName}
                  location={location}
                  machine={machine}
                />
              </>
            )}
          </SwitchNameSelectorWrapper>
        </Wrapper>
      )}
    </>
  );
};

export default SSRDetail;
const SectionContainer = styled.section`
  width: 100%;
  ${justifyContentSpaceBetween}

  ${(p) =>
    p.isFirst &&
    css`
      ${justifyContentFlexEnd};
    `};

  ${(p) =>
    p.isLast &&
    css`
      ${flexBoxCenter};
    `}
`;


const Wrapper = styled.div`
  ${(p) =>
    p.isMobile
      ? css`
          width: 289px;
          min-height: 151px;
          border-radius: 16px;
          margin-bottom: 8px;
          ${flexDirectionColumn};
          align-items: stretch;
          padding: 8px 6px;
          position: relative;

          background: transparent
            linear-gradient(
              180deg,
              ${p.isOff ? '#565656' : '#233a54'} 0%,
              ${p.isOff ? '#1d1d1d' : '#060d19'} 100%
            );
          box-shadow: inset 0px 0.5px 1px #ffffff29, 0px 0px 1px #000000;
          border: 0.5px solid #000000;

          ${p.isFault &&
          css`
            border: 1px solid red;
          `}

          ${p.isOverAmp &&
          css`
            border: 1px solid #ff7800;
          `}
        `
      : css`
          width: 100%;

          display: flex;
          flex-direction: column;
          padding: 0 5px;

          margin-bottom: 5px;

          transition: all 200ms ease-in-out;


          position: relative;
        `}
`;

const FlexContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;


`;

const ToggleSWitchContainer = styled.div`
  ${(p) =>
    p.isMobile &&
    css`
      flex-shrink: 0;
    `}
`;

const MobileHeaderRow = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween};
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 6px;
`;

const HeaterBlock = styled.div`
  width: 100%;
  ${flexDirectionColumn};
  align-items: stretch;

  & + & {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 0.5px solid #ffffff29;
  }
`;

const HeaterBlockTitle = styled.span`
  font-size: 8px;
  color: #95ff45;
  text-align: left;
  margin-bottom: 2px;
`;

const HeaterFigures = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-around;
  gap: 4px 8px;

  > div:first-child {
    margin-left: 0;
  }
`;

const MobileSettingButton = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  ${layerA};
  ${flexBoxCenter};

  ${(p) =>
    p.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

const MobileSettingIcon = styled.img`
  height: 60%;
`;

const MobilePasswordWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  ${flexBoxCenter};
  z-index: 100;
  cursor: pointer;
`;

const SwitchNameSelectorWrapper = styled.div`
  position: absolute;
  top: 62px;
  width: 183px;
  height: auto;
  ${alignItemsFlexStart};
  flex-direction: column;
  gap: 6px;
`;
